<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3b"><a id="page_9"></a><a id="ch4"></a><em>Curve</em></h3>
<p class="noindent">Freezeburn forms whirlpools and bearfur has curve.</p>
<p class="noindent">My line is gravity’s</p>
<p class="noindent">sheer vertical.</p>
<p class="noindentt">Memory’s the same</p>
<p class="noindent">seme. Sail a memo</p>
<p class="noindent">down: there’s the spooled</p>
<p class="noindentt">real: plunge into simulcast.</p>
<p class="noindent">Caught up in the network is</p>
<p class="noindent">a blue planet, spinner par</p>
<p class="noindent">excellence.</p>
<p class="noindentt">It’s too small.</p>
<p class="noindent">Throw it back.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter04.vue?402650e8